// =============================================================================
// child.js — the child theme's JS entry (Vite → assets/dist/js/child-theme.js,
// emitted as an ES module and tagged type="module" by functions.php).
//
// Scope: ONLY the behavior-map rows owned by this file (block-map §3):
//   row 1  hamburger toggle `.cleo-header__toggle` → `.cleo-header__nav`
//          (`is-open` + `aria-expanded`)          → modules/header-nav.js
//   row 2  mobile nav link click → close dropdown → modules/header-nav.js
//
// S8 checkout (user decision 2026-09-11), one addition:
//   row 18b `?payment_method={gateway id}` on /checkout/ preselects the
//          matching gateway radio → modules/checkout-preselect.js. Needed
//          because the parent's React checkout defaults to `cod` and reads no
//          URL param (CheckoutApp.jsx:68); the wizard's "Pay & confirm" hands
//          off with that param.
//
// Explicitly NOT here:
//   row 3  nav links are real <a href> and the active pill is rendered
//          server-side from the route (body_class) — no JS.
//   row 5  `cleoFade` page/panel entrance is CSS-only (ui-spec §7): the
//          keyframe lives in _base.scss and is applied with the
//          `@include cleo-fade(...)` mixin. No IntersectionObserver, no
//          `.visible` class toggling.
//   rows 9–23  the booking wizard is self-contained in its own
//          `blocks/treatments-booking/view.js` (block viewScript), NOT here.
//   rows 29–31  AJAX add-to-cart and the shop filter are parent-owned
//          (Decision 4). The mini-cart drawer that used to sit here was
//          removed at S16g (block deleted from parts/header.html), so the
//          child no longer reskins any `.az-mc__*`.
//
// Vanilla JS. No jQuery, no framework.
// =============================================================================

import { initHeaderNav } from "./modules/header-nav.js";
import { initCheckoutPreselect } from "./modules/checkout-preselect.js";
import { initDetailSheet } from "./modules/detail-sheet.js";

function boot() {
	initHeaderNav();
	initCheckoutPreselect();
	initDetailSheet(); // S37: treatment bottom sheets on home AND /treatments/
}

// Vite emits ESM, so this file is deferred and runs before DOMContentLoaded;
// the readyState check keeps it correct if the tag is ever inlined instead.
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
	boot();
}
